function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs4530"
});

var SvgListLeftActive = function SvgListLeftActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 5.2916666 4.2333335",
    id: "svg4536",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5132",
    transform: "matrix(1.9511383,0,0,1.9511383,14.420128,-0.10857964)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.178585,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "circle5110",
    cx: -7.1578512,
    cy: 2.0104916,
    r: 0.17938247
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.178585,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "circle5112",
    cx: -7.1578512,
    cy: 1.2309155,
    r: 0.17938247
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 0.4395279,
    cx: -7.1578512,
    id: "path5092",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.178585,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    r: 0.17938247
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.159681,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect5122",
    width: 1.9377041,
    height: 0.35876495,
    x: -6.6690836,
    y: 0.2601454,
    rx: 0.12297712
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.159681,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect5124",
    width: 1.9377041,
    height: 0.35876495,
    x: -6.6690836,
    y: 1.0515331,
    rx: 0.12297712
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 0.123,
    y: 1.831109,
    x: -6.6690836,
    height: 0.35876495,
    width: 1.4416103,
    id: "rect5120",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 29.6901,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListLeftActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-left-active.2efb07f5.svg";
export { ForwardRef as ReactComponent };